import {
    ComponentStoreV2Factory,
} from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import {
    SERVICE_TYPE_SETTING_MULTI_PERSON_FOLDER,
} from '@libs/types/src/services/types/service-settings-folder-persons.type';

@Injectable()
export class ServiceTypeSettingsPageStore extends ComponentStoreV2Factory {

    public serviceType = computed(() => this.globalGlobalStore.serviceTypeStore.serviceType());

    // settings je jsonb serializovaný do Stringu, parsujeme obranně
    public settings = computed<Record<string, unknown>>(() => {
        const raw = this.serviceType()?.settings;
        if (!raw) return {};

        try {
            return typeof raw === 'string' ? JSON.parse(raw) : raw as Record<string, unknown>;
        } catch {
            return {};
        }
    });

    public multiPersonFolder = computed(
        () => this.settings()[SERVICE_TYPE_SETTING_MULTI_PERSON_FOLDER] === true,
    );

}
